import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getProjectEntriesState, dismissFeedback, getEntry } from 'project/ducks/entries';
import { getRevisionById } from 'project/utils';
import Feedback from 'project/components/entries/feedback';

export function mapStateToProps(state) {
  const { scoredRevision, feedbackSent } = getProjectEntriesState(state);
  const revision = getRevisionById(state, scoredRevision);
  const { author_username, entry_type } = getEntry(state, revision.entry);
  return { ...revision, entry_type, author_username, feedbackSent };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    onHide: dismissFeedback,
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Feedback));



// WEBPACK FOOTER //
// ./project/containers/entries/feedback.js